<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Widgets" pageTitle="Widgets" />
            <WidgetsContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import WidgetsContent from '../Widgets/WidgetsContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'WidgetsPage',
    components: {
        MainHeader,
        PageTitle,
        WidgetsContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>